import React, { useState } from 'react'
import RichGrid from '../../../../components/richgrid/RichGrid'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setBulkAddressMatchModalOpen } from '../RecipientListSlice'
import Label from '../../../../components/label/Label'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import styles from "./BulkAddressMatch.styles"
import Heading from '../../../../components/heading/Heading'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown'
import Button from '../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import { HEADING } from '../../../../components/heading/constants/constants'
import { FILTER_OPTIONS } from './constants'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { bulkAddressMatch } from '../RecipientListSaga'
import { componentKey as recipientSectionKey } from '../../RecipientsSectionSlice'
import Loadable from '../../../../components/loadable/Loadable'
import { RECIPIENT_LISTING_LOADING_STATES, RECIPIENT_LISTING_MESSAGE_MAP } from '../constants'

export default function BulkAddressMatch() {

    const { loadingState, selectedRecipients, highlightedRecipient } = useSelector(state => state[componentKey]);
    const { selectedPayer } = useSelector(state => state[recipientSectionKey]);

    const [selectedFilter, setSelectedFilter] = useState(FILTER_OPTIONS[0]);

    const dispatch = useDispatch();

    const BULK_ADDRESS_MATCH_COLUMNS = [
        {
            field: "S.No.",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>S.No.</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{idx + 1}</span>
        },
        {
            field: "Recipient",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{`${row?.FirstName} ${row?.LastName}`}</span>
        },
        {
            field: "Address",
            header: <Label weight={LABEL_WEIGHT[700]}>Address</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{`${row?.Address1}, ${row?.Address2}`}</span>
        },
        {
            field: "City",
            header: <Label weight={LABEL_WEIGHT[700]}>City</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row?.City}</span>
        },
        {
            field: "State",
            header: <Label weight={LABEL_WEIGHT[700]}>State</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row?.State}</span>
        },
        {
            field: "ZIPCode",
            header: <Label weight={LABEL_WEIGHT[700]}>ZIP Code</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row?.ZipCode}</span>
        },
        {
            field: "Action",
            header: <Label weight={LABEL_WEIGHT[700]}>Action</Label>,
            renderLogic: (row, idx) => <Icons iconName={row?.USPSValid ? VEC_ICON_NAME.START_TICK_ICON : VEC_ICON_NAME.CIRCULAR_EXCLAMATORY} familyName="vec" />
        },

    ];

    let gridData = selectedRecipients.length ? selectedRecipients : highlightedRecipient?.RecipentDetailId ? [highlightedRecipient] : [];

    gridData = gridData.filter(d => d.Country == "US");

    return (
        <>
            <div style={styles.tableContainer}>

                <p>Use our service to validate the physical addresses of your recipients before mailing forms to ensure the address matches USPS format.</p>
                <p style={styles.note}>Note: You can only validate addresses for recipients living in US</p>

                <Loadable
                    currentState={loadingState?.state}
                    loadingStates={[RECIPIENT_LISTING_LOADING_STATES.BULK_ADDRESS_MATCH_LOADING]}
                    isNewLoadable={true}
                    messageMap={RECIPIENT_LISTING_MESSAGE_MAP}
                >
                    <div style={styles.headerContainer}>
                        <Heading type={HEADING.H2}>List of {gridData.length} addresses selected.</Heading>

                        <SelectDropdown
                            label='Filter'
                            value={selectedFilter}
                            options={FILTER_OPTIONS}
                            onSelectCb={(name, selectedOption) => setSelectedFilter(selectedOption)}
                        />
                    </div>

                    <RichGrid
                        data={gridData}
                        columns={BULK_ADDRESS_MATCH_COLUMNS}
                    />

                    <div style={styles.buttonsContainer}>

                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => dispatch(bulkAddressMatch({ selectedPayer, selectedRecipients: gridData }))}>Process List</Button>

                        <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => dispatch(setBulkAddressMatchModalOpen(false))}>Cancel</Button>
                    </div>
                </Loadable>
            </div>
        </>
    )
}